import BoardOfSecurity from './components/BoardOfSecurity'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <BoardOfSecurity />
    </div>
  )
}

export default App
